import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

// This stylesheet is for common styles that across the cards
export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 36px;
  > a {
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.2) 0.15%, rgba(0, 0, 0, 0) 39.69%);
  }
  @media screen and (${query.below('tablet')}) {
    margin-bottom: ${space('xl')};
  }
`;

export const ImageWrapper = styled.div<{ $imageAspectRatio?: string }>`
  width: 100%;
  height: ${({ $imageAspectRatio }) => ($imageAspectRatio ? 0 : 'auto')};
  padding-bottom: ${({ $imageAspectRatio }) => ($imageAspectRatio ? $imageAspectRatio : 'none')};
  position: relative;
  background-color: ${color('gray1')};
`;

export const MediaImageWrapper = styled.div<{ $imageAspectRatio?: string }>`
  width: 100%;
  height: ${({ $imageAspectRatio }) => ($imageAspectRatio ? 0 : 'auto')};
  padding-bottom: ${({ $imageAspectRatio }) => ($imageAspectRatio ? $imageAspectRatio : 'none')};
  position: relative;
  margin-bottom: ${space('xl')};
  background-color: ${color('secondaryBg')};

  @media screen and (${query.below('desktop')}) {
    margin-bottom: ${space('lg')};
  }

  > span,
  > a > span {
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    padding: ${space('x10')};
    box-sizing: border-box;

    @media screen and (${query.below('desktop')}) {
      padding: ${space('x8')};
    }

    > span {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
    }
  }

  img {
    //make the image grayscale are remove background color (which should be white )
    filter: grayscale(100%);
    mix-blend-mode: multiply;
  }
`;

export const EmptyCardImage = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 75%;
  background-color: ${color('gray1')};
`;

export const CardHeaderWrapper = styled.div<{ $subHeader?: boolean }>`
  margin: ${space('xl')} 0;
  /* margin-bottom: ${space('md')}; */
  display: flex;
  flex-direction: ${({ $subHeader }) => ($subHeader ? 'column' : 'row')};
  align-items: ${({ $subHeader }) => ($subHeader ? 'flex-start' : 'center')};
  width: 100%;
  justify-content: space-between;

  @media screen and (${query.below('desktop')}) {
    margin-top: ${space('lg')};
    margin-bottom: ${space('lg')};
  }

  a {
    color: ${color('fg')};
    text-decoration: none;
    color: ${color('fg')};

    &:visited {
      color: ${color('fg')};
    }
    &:hover {
      color: ${color('gray5')};
    }
  }
`;

export const CardHeaderStyled = styled.h3<{ $subHeader?: boolean }>`
  display: inline-block;
  ${font('subhead-md')};
  //if subheader is present the no padding bottom
  padding-bottom: ${({ $subHeader }) => ($subHeader ? space('xs') : 0)};

  @media screen and (${query.below('tablet')}) {
    ${font('subhead-sm')};
  }
`;

export const CardSubHeaderStyled = styled.h4`
  ${font('body-lg')};
  line-height: 1.15;
  padding-bottom: 0;

  @media screen and (${query.below('desktop')}) {
    ${font('body-sm')};
    line-height: 1.15;
  }
`;

export const CardContentWrapper = styled.div``;

// Detail List Styles
export const CardContentDetailListStyled = styled.ul`
  list-style: none;
  margin-bottom: ${space('xl')};
  margin-top: -2px; // slight correction to match figma
  ${font('body-md-light')};
  color: ${color('gray4')};
  line-height: 1.3; // change to special 1.3 to be slightly different from each line

  @media screen and (${query.below('desktop')}) {
    ${font('body-sm-light')};
    line-height: 1.3; // change to special 1.3 to be slightly different from each line
    margin-bottom: ${space('lg')};
  }

  > li {
    display: block;
  }

  a {
    color: ${color('gray4')};
    text-decoration: none;
    border-bottom: 1px solid ${color('gray4')};
    transition:
      border-color 0.2s ease-in-out,
      color 0.2s ease-in-out;

    &:visited {
      color: ${color('gray4')};
    }

    &:hover {
      color: ${color('gray5')};
      border-color: ${color('gray5')};
    }

    &.phone-link {
      border: none;
    }
  }
  a.phone {
    border-bottom: none;
  }
`;

// Small spacer for Media and Article Cards
export const StyledSpacer = styled.hr`
  border: 1px solid ${color('cta')};
  width: 28px;
  height: 0px;
  margin: 0 0 ${space('xl')} 0;

  @media screen and (${query.below('desktop')}) {
    margin-bottom: ${space('lg')};
  }
`;

// For use in Story
export const CardStoryWrapper = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
`;
